import { gql } from '@apollo/client'
import React from 'react'

import { sessionsClient } from '../../../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../../../utils/apollo/_helpers/pagination'
import { usePublicToken } from '../../../_load/PublicTokenLoader'
import LazyAction from '../../../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePublicTokenCallsState = () => React.useContext(Context)
export const usePublicTokenCalls = () => usePublicTokenCallsState()?.publicTokenCalls

const QUERY = gql`
  query PublicTokenCalls($filter: PublicTokenCallFilter, $page: Int) {
    publicTokenCalls(page: $page, filter: $filter, sort: { field: INSERTED_AT, type: DESC }) {
      id
      status
      insertedAt
      data
    }
  }
`

const PublicTokenCallsLoader = ({ children }) => {
  const publicToken = usePublicToken()

  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      filter: { tokens: publicToken.token }
    },
    client: sessionsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
      <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
    </StatePresenter>
  )
}
export default PublicTokenCallsLoader
